// extracted by mini-css-extract-plugin
module.exports = {"root":"Item_root__3tW0F","icon":"Item_icon__3lp0D","name":"Item_name__G9RXX","checked":"Item_checked__2CkIZ"};